import { useEffect, useMemo, useRef, useState } from "react";

import { Input } from "./input";

export function BoxInput({
  length,
  onChange,
}: {
  length: number;
  onChange: (value: string) => void;
}) {
  const [values, setValues] = useState<string[]>(() =>
    Array.from({ length }, () => ""),
  );
  const refs = useRef<Array<HTMLInputElement | null>>([]);

  const slots = useMemo(() => Array.from({ length }, (_, i) => i), [length]);

  const updateValues = (nextValues: string[]) => {
    setValues(nextValues);
    onChange(nextValues.join(""));
  };

  useEffect(() => {
    setValues((current) => {
      if (current.length === length) {
        return current;
      }

      const resized = Array.from({ length }, (_, idx) => current[idx] ?? "");
      onChange(resized.join(""));
      return resized;
    });
  }, [length, onChange]);

  return (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      {slots.map((idx) => (
        <Input
          key={idx}
          ref={(el) => {
            refs.current[idx] = el;
          }}
          className="text-center w-10 uppercase"
          maxLength={1}
          type="text"
          value={values[idx] ?? ""}
          onChange={(e) => {
            const char = e.target.value.slice(-1).toUpperCase();
            const nextValues = [...values];
            nextValues[idx] = char;
            updateValues(nextValues);

            if (char && idx < length - 1) {
              refs.current[idx + 1]?.focus();
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "ArrowLeft" && idx > 0) {
              refs.current[idx - 1]?.focus();
            }

            if (e.key === "ArrowRight" && idx < length - 1) {
              refs.current[idx + 1]?.focus();
            }

            if (e.key === "Backspace") {
              if (values[idx]) {
                const nextValues = [...values];
                nextValues[idx] = "";
                updateValues(nextValues);
              } else if (idx > 0) {
                const previousIndex = idx - 1;
                const nextValues = [...values];
                nextValues[previousIndex] = "";
                updateValues(nextValues);
                refs.current[previousIndex]?.focus();
              }
            }
          }}
        />
      ))}
    </div>
  );
}
